/** Available HTTP methods for Hono routes */
const httpMethods = ['get', 'put', 'post', 'delete', 'options', 'patch'];

export { httpMethods };
